/*! Solva — live cart counter (hardened).
 *  Keeps every [data-cart-count] element in sync with cart.item_count without
 *  a page refresh. Hooks fetch + XHR, listens to many cart events, polls while
 *  the tab is visible, and re-syncs on tab focus / pageshow / BFCache. */
(function(){
  if (window.__solvaCartCounter) return;
  window.__solvaCartCounter = true;

  var POLL_MS = 30000;
  var inflight = false;
  var lastCount = null;
  var pollTimer = null;

  function applyCount(n){
    n = Number(n) || 0;
    var els = document.querySelectorAll('[data-cart-count]');
    Array.prototype.forEach.call(els, function(el){
      el.textContent = String(n);
      el.classList.toggle('is-empty', n === 0);
    });
    lastCount = n;
  }

  function refresh(){
    if (inflight) return;
    inflight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (cart && typeof cart.item_count === 'number') applyCount(cart.item_count);
      })
      .catch(function(){})
      .finally(function(){ inflight = false; });
  }

  function startPoll(){
    stopPoll();
    pollTimer = setInterval(function(){
      if (document.visibilityState === 'visible') refresh();
    }, POLL_MS);
  }
  function stopPoll(){ if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }

  // First sync — initial + cached + BFCache.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  window.addEventListener('pageshow', refresh);

  // Tab focus / visibility — many users switch away and come back.
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('focus', refresh);

  // Common cart events fired by Shopify themes / drawer apps / popular cart UIs.
  var EVENTS = [
    'cart:refresh', 'cart:updated', 'cart:build', 'cart:added', 'cart:open',
    'cart-update', 'cart-updated', 'cart-added',
    'ajaxProduct:added', 'theme:cart:open',
    'upcart:refresh', 'upcart:open', 'upcart:updated',
    'bold-cart:refresh', 'bold-cart:updated',
    'rebuy:cart.add', 'rebuy:cart.update'
  ];
  EVENTS.forEach(function(ev){
    document.addEventListener(ev, refresh);
    window.addEventListener(ev, refresh);
  });

  // Subscribe to Shopify's Section Rendering pub/sub if the theme uses it.
  if (typeof window.subscribe === 'function') {
    try { window.subscribe('cart-update', refresh); } catch(e){}
  }

  // Patch fetch — refresh after any /cart/add|change|update|clear call.
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isChange = /\/cart\/(add|change|update|clear)/.test(url);
      var p = origFetch.apply(this, arguments);
      if (isChange) { p.then(refresh).catch(function(){}); }
      return p;
    };
  }

  // Patch XHR — same coverage as fetch.
  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__solvaUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      if (/\/cart\/(add|change|update|clear)/.test(this.__solvaUrl || '')) {
        this.addEventListener('load', refresh);
      }
      return origSend.apply(this, arguments);
    };
  }

  startPoll();
})();
